import { error } from "jquery";
import { ADD_ARTWORK_FORM, ADD_ARTWORK_FORM_FAIL, ADD_ARTWORK_FORM_SUCCESS, ADD_PRINT_REQUEST, ADD_PRINT_REQUEST_FAIL, ADD_PRINT_REQUEST_SUCCESS, ADD_PRINT_TRANS, ADD_PRINT_TRANS_FAIL, ADD_PRINT_TRANS_SUCCESS, GET_ARTWORK_FORM, GET_ARTWORK_FORM_FAIL, GET_ARTWORK_FORM_SUCCESS, GET_CHECK_INTENT, GET_CHECK_INTENT_FAIL, GET_CHECK_INTENT_SUCCESS, GET_PRINTER_FROM_PRODUCT, GET_PRINTER_FROM_PRODUCT_FAIL, GET_PRINTER_FROM_PRODUCT_SUCCESS, GET_PRINTER_LIST, GET_PRINTER_LIST_FAIL, GET_PRINTER_LIST_SUCCESS, GET_PRINTING_REQUESTS_OWNER_ID, GET_PRINTING_REQUESTS_OWNER_ID_FAIL, GET_PRINTING_REQUESTS_OWNER_ID_SUCCESS, GET_PRINTING_REQUESTS_USER_ID, GET_PRINTING_REQUESTS_USER_ID_FAIL, GET_PRINTING_REQUESTS_USER_ID_SUCCESS, PRINT_REQUEST_TRANS, PRINT_REQUEST_TRANS_FAIL, PRINT_REQUEST_TRANS_SUCCESS, WITHDRAW_REQUEST_SELLER, WITHDRAW_REQUEST_SELLER_FAIL, WITHDRAW_REQUEST_SELLER_SUCCESS } from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  printRequset: {},
  printRequsets: [],
  printCount: 0,
  Printers: [],
  artWorkForm: {},
  printRequestFromOwnerId: [],
  printerList: [],
  intentData:{},
  fiatTotalEarning: 0, 
  fiat_available_amount:0,
  withdrawals:[]
};

const Print = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_PRINT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADD_PRINT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,

      };

    case ADD_PRINT_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };


    case GET_PRINTER_FROM_PRODUCT:
      return {
        ...state,
        loading: true,
      };

    case GET_PRINTER_FROM_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        Printers: action.payload || []
      };

    case GET_PRINTER_FROM_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



    case GET_PRINTING_REQUESTS_USER_ID:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case GET_PRINTING_REQUESTS_USER_ID_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        printRequsets: action.payload || []
      };
    case GET_PRINTING_REQUESTS_USER_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    //
    case GET_PRINTING_REQUESTS_OWNER_ID:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case GET_PRINTING_REQUESTS_OWNER_ID_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        printRequestFromOwnerId: action.payload || []
      };
    case GET_PRINTING_REQUESTS_OWNER_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    //

    case ADD_PRINT_TRANS:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ADD_PRINT_TRANS_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
      };
    case ADD_PRINT_TRANS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ADD_ARTWORK_FORM:
      return {
        ...state,
        error: "",
        loading: true,
      };

    case ADD_ARTWORK_FORM_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
      };
    case ADD_ARTWORK_FORM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case GET_ARTWORK_FORM:
      return {
        ...state,
        error: "",
        loading: true,

      };

    case GET_ARTWORK_FORM_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        artWorkForm: action.payload
      };
    case GET_ARTWORK_FORM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



    case GET_PRINTER_LIST:
      return {
        ...state,
        error: "",
        loading: true,

      };

    case GET_PRINTER_LIST_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        printerList: action.payload
      };
    case GET_PRINTER_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };



      case GET_CHECK_INTENT:
        return {
          ...state,
          error: "",
          loading: true,
  
        };
  
      case GET_CHECK_INTENT_SUCCESS:
        return {
          ...state,
          error: '',
          loading: false,
          intentData: action.payload
        };
      case GET_CHECK_INTENT_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload
        };



        case WITHDRAW_REQUEST_SELLER:
          return {
            ...state,
            error: "",
            loading: true,
    
          };
    
        case WITHDRAW_REQUEST_SELLER_SUCCESS:
          return {
            ...state,
            error: '',
            loading: false,
            // intentData: action.payload
          };
        case WITHDRAW_REQUEST_SELLER_FAIL:
          return {
            ...state,
            loading: false,
            error: action.payload
          };






          case PRINT_REQUEST_TRANS:
            return {
              ...state,
              error: "",
              loading: true,
      
            };
      
          case PRINT_REQUEST_TRANS_SUCCESS:
            console.log("fasdfasdfasdfasd", action)
            return {
              ...state,
              error: '',
              loading: false,
              fiatTotalEarning: action.payload.fiat_total_earning,
              fiat_available_amount:action.payload.fiat_available_amount,
              withdrawals:action.payload.withdrawals
            };
          case PRINT_REQUEST_TRANS_FAIL:
            return {
              ...state,
              loading: false,
              error: action.payload
            };
  




    default:
      return state;
  }
};

export default Print;